import { useEffect } from 'react';

/**
 * Rotates winners thumbnails in grid.
 * Depending on gridPosition - thumbnail gets own rotation step and speed
 */
export const useWinnersRotationDesktop = (
    winners,
    gridPosition,
    setCurrentWinner,
    dependencies = [],
) => {
    useEffect(() => {
        /**
         * 1st element will refresh each 10s
         * 2nd element will refresh each 14s
         * 3rd element will refresh each 18s
         */
        const timeoutToPositionMs = [
            10000,
            14000,
            18000,
        ];
        let intervalId;
        const winnersCount = winners.length;

        if (winnersCount > 0) {
            let winnerIndex = gridPosition;
            setCurrentWinner(winners[winnerIndex]);

            // if there are more than 1 winner - loop over them each X seconds
            if (winnersCount > 1) {
                const timeout = timeoutToPositionMs[gridPosition] || timeoutToPositionMs[0];
                const rotationStep = 3;

                intervalId = setInterval(() => {
                    // loop through winners cyclically with step
                    winnerIndex += rotationStep;

                    // this means next step is out of winners bounds
                    // get new winner from beginning but related to gridPosition
                    // e.g. 3rd winner thumbnail will start over winners array with index 2, not 0
                    if (winnersCount - 1 < winnerIndex) {
                        winnerIndex = Math.abs(winnersCount - winnerIndex);
                    }

                    let nextWinner = winners[winnerIndex];
                    if (!nextWinner) {
                        nextWinner = winners[gridPosition];
                        winnerIndex = gridPosition;
                    }

                    setCurrentWinner(nextWinner);
                }, timeout);
            }
        }

        return () => {
            clearInterval(intervalId);
        };
    }, dependencies);
};
